import type { CityConfig } from "../city-template/types";

export const portsmouthVaConfig: CityConfig = {
  city: "Portsmouth",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "portsmouth-va",
  route: "/portsmouth-va",
  title: "Emergency Passport Portsmouth, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Portsmouth, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Norfolk Naval Shipyard, Olde Towne, and all Hampton Roads travelers. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Portsmouth, VA",
  heroSubtitle: "Passport expired before deployment or cruise departure? Need an emergency passport fast? We help Portsmouth and Hampton Roads travelers — including Navy personnel at the Norfolk Naval Shipyard, America's oldest and largest shipyard — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20photograph%20of%20Portsmouth%20Virginia%20at%20golden%20hour%20with%20the%20historic%20Olde%20Towne%20waterfront%20district%2C%20colonial%20architecture%20along%20the%20Elizabeth%20River%2C%20Norfolk%20Naval%20Shipyard%20with%20dry%20docks%20and%20ships%20visible%20in%20the%20background%2C%20the%20Midtown%20Tunnel%20bridge%20crossing%20the%20river%2C%20warm%20amber%20sunset%20colors%20reflecting%20on%20the%20water%2C%20lush%20green%20trees%20along%20the%20riverfront%2C%20clean%20professional%20cityscape%20photography%20with%20vivid%20warm%20tones%2C%20no%20text%20or%20signs%20visible&width=1800&height=700&seq=portsmouth-va-hero-001&orientation=landscape",
  heroImageAlt: "Portsmouth Virginia historic Olde Towne waterfront at sunset with Norfolk Naval Shipyard in the background",
  geoPosition: "36.8354;-76.2983",
  geoPlacename: "Portsmouth, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 200 miles from Portsmouth via I-64 and I-95",
  },
  nearbyCitiesZips: [
    { name: "Portsmouth", zips: "23701–23709" },
    { name: "Norfolk", zips: "23501–23523" },
    { name: "Chesapeake", zips: "23320–23328" },
    { name: "Virginia Beach", zips: "23450–23479" },
    { name: "Suffolk", zips: "23432–23439" },
    { name: "Hampton", zips: "23661–23669" },
    { name: "Newport News", zips: "23601–23609" },
    { name: "Williamsburg", zips: "23185, 23188" },
    { name: "Richmond", zips: "23219–23242" },
    { name: "Olde Towne", zips: "23704" },
    { name: "Churchland", zips: "23703" },
    { name: "Cradock", zips: "23702" },
    { name: "West Norfolk", zips: "23701" },
    { name: "Park View", zips: "23701" },
    { name: "Norfolk Naval Shipyard", zips: "23709" },
    { name: "Brighton", zips: "23707" },
    { name: "Midtown", zips: "23704" },
    { name: "Hodges Ferry", zips: "23701" },
    { name: "Charlottesville", zips: "22901–22911" },
    { name: "Roanoke", zips: "24001–24020" },
    { name: "Fredericksburg", zips: "22401–22408" },
    { name: "Arlington", zips: "22201–22217" },
    { name: "Alexandria", zips: "22301–22315" },
    { name: "McLean", zips: "22101, 22102" },
    { name: "Fairfax", zips: "22030, 22031" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Portsmouth departures and shipyard deployments" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Hampton Roads Hub", desc: "Serving Portsmouth, Norfolk, Chesapeake, and all of Hampton Roads" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Norfolk passport services", route: "/norfolk-va" },
    { name: "Chesapeake passport services", route: "/chesapeake-va" },
    { name: "Virginia Beach passport services", route: "/virginia-beach" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Portsmouth remotely via secure courier. We do not have a walk-in office in Portsmouth — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Hampton Roads travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Portsmouth and the Hampton Roads region including Norfolk, Chesapeake, Virginia Beach, Suffolk, Hampton, and Newport News",
  serviceAreaIntro: "From Olde Towne to Churchland, from Cradock to West Norfolk, from Park View to Hodges Ferry — Fast Passport Center serves the entire Hampton Roads region. We regularly help Navy shipyard workers, Marine families, and Coast Guard members, plus civilian travelers and business professionals, get their passports fast.",
  nearbyCitiesIntro: "We serve all Portsmouth neighborhoods and the surrounding Hampton Roads region including Norfolk, Chesapeake, Virginia Beach, Suffolk, Hampton, Newport News, Williamsburg, and extending to Richmond, Charlottesville, and Fredericksburg. If you are anywhere in the Hampton Roads metropolitan area, we have you covered.",
  howItWorksIntro: "Most Portsmouth travelers complete everything online and ship documents overnight. No need to drive to Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Portsmouth travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Portsmouth and Hampton Roads travelers trust us when their deployment, vacation, or business trip is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Portsmouth? Here are the most common ones we hear from Hampton Roads travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Portsmouth and Hampton Roads residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Portsmouth Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.portsmouthva.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Portsmouth Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.portsmouthva.gov/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Portsmouth international flights and shipyard deployments.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "James W.",
      location: "Cradock, Portsmouth, VA",
      rating: 5,
      text: "Got emergency orders to report to the shipyard in Japan. Fast Passport Center had my passport in 36 hours. They understood the shipyard urgency and the whole process was seamless. Never had to leave Portsmouth.",
      service: "Emergency Passport",
    },
    {
      name: "Patricia M.",
      location: "Olde Towne, Portsmouth, VA",
      rating: 5,
      text: "Booked a Caribbean cruise out of Norfolk and realized my passport was expired 2 weeks before sailing. Fast Passport Center had it renewed in 3 days. I shipped from the Portsmouth UPS Store downtown and never worried once.",
      service: "Passport Renewal",
    },
    {
      name: "David R.",
      location: "Churchland, Portsmouth, VA",
      rating: 5,
      text: "First passports for my two kids before our family trip to Italy. Fast Passport Center walked us through the parental consent requirements and had everything ready in 5 days. The dedicated agent was incredibly helpful.",
      service: "Child Passport",
    },
    {
      name: "Lisa T.",
      location: "West Norfolk, Portsmouth, VA",
      rating: 5,
      text: "Lost my passport the night before a business trip to London. Fast Passport Center had a replacement in my hands in 30 hours. Absolutely incredible service for anyone in the Portsmouth area.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "portsmouth-1",
      name: "Portsmouth Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 Crawford St",
      city: "Portsmouth",
      state: "VA",
      zip: "23704",
      phone: "(757) 397-0521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Portsmouth, Olde Towne district",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Portsmouth facility in historic Olde Towne. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-2",
      name: "Norfolk Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "555 E Main St",
      city: "Norfolk",
      state: "VA",
      zip: "23510",
      phone: "(757) 625-3161",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Norfolk, approximately 5 miles east via Downtown Tunnel",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Hampton Roads facility. Full passport services with appointment. Convenient for Portsmouth residents working in Norfolk.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-3",
      name: "Chesapeake Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1400 Plaza Dr",
      city: "Chesapeake",
      state: "VA",
      zip: "23320",
      phone: "(757) 547-3461",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Western Portsmouth, Chesapeake city center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chesapeake and western Portsmouth. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-4",
      name: "Virginia Beach Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1355 Laskin Rd",
      city: "Virginia Beach",
      state: "VA",
      zip: "23451",
      phone: "(757) 425-2191",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Virginia Beach, approximately 20 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Hampton Roads facility serving Virginia Beach and Portsmouth. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-5",
      name: "Norfolk Naval Shipyard Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "900 B St",
      city: "Portsmouth",
      state: "VA",
      zip: "23709",
      phone: "(757) 397-5521",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Naval Shipyard area, Portsmouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Navy shipyard personnel and base workers. Limited hours — call ahead for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-6",
      name: "Suffolk Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1001 N Main St",
      city: "Suffolk",
      state: "VA",
      zip: "23434",
      phone: "(757) 539-3111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Suffolk, approximately 20 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Suffolk and western Portsmouth. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5 hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Portsmouth photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hampton Roads acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Portsmouth applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hampton Roads families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Portsmouth travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Portsmouth." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Portsmouth address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Portsmouth before international travel or shipyard deployment?", a: "Yes. Fast Passport Center provides emergency passport services in Portsmouth for travelers with urgent international flights and Navy personnel with shipyard deployment orders. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5 hour drive to Washington, DC." },
    { q: "How fast can I renew my passport in Portsmouth?", a: "Fast Passport Center offers fast passport renewal in Portsmouth in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Portsmouth?", a: "The nearest regional passport agency to Portsmouth is the Washington Passport Agency, approximately 200 miles away via I-64 and I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Portsmouth without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Portsmouth?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency — approximately 3.5 hours from Portsmouth — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Hampton Roads residents." },
    { q: "Can I expedite a child passport in Portsmouth?", a: "Yes. Fast Passport Center expedites child passports in Portsmouth for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Hampton Roads families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Portsmouth with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Portsmouth?", a: "With Fast Passport Center's emergency courier service, Portsmouth travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Portsmouth?", a: "Popular options include the Portsmouth Main Post Office (23704), Norfolk Main Post Office (23510), Chesapeake Main Post Office (23320), Virginia Beach Main Post Office (23451), Norfolk Naval Shipyard Post Office (23709), and Suffolk Main Post Office (23434). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Portsmouth?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 3.5 hour drive to DC." },
    { q: "What if I work at the Norfolk Naval Shipyard?", a: "We serve all Navy shipyard personnel and military families stationed at the Norfolk Naval Shipyard, America's oldest and largest shipyard. Our overnight shipping labels work from any UPS location, including the shipyard area. We understand military orders and deployment urgency, and can process passports as fast as 24–48 hours." },
    { q: "How much does expedited passport service cost in Portsmouth?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help Navy shipyard workers in Portsmouth?", a: "Absolutely. We regularly assist Navy personnel and civilian shipyard workers at the Norfolk Naval Shipyard. We understand PCS orders, deployment urgency, and TDY travel needs. We can process passports as fast as 24–48 hours for orders and emergency leave." },
    { q: "Do you help with passport photos in Portsmouth?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and Walmart locations in Portsmouth, Norfolk, and Chesapeake offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Portsmouth?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Portsmouth?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Hampton Roads families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Portsmouth", address: "3938 Portsmouth Blvd, Portsmouth, VA 23701", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Portsmouth", address: "4000 Victory Blvd, Portsmouth, VA 23701", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Portsmouth", address: "1098 Frederick Blvd, Portsmouth, VA 23707", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Portsmouth", address: "5601 High St W, Portsmouth, VA 23703", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Norfolk", address: "850 W 21st St, Norfolk, VA 23517", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Chesapeake", address: "2001 S Military Hwy, Chesapeake, VA 23320", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Chesapeake", address: "2448 Chesapeake Square Ring Rd, Chesapeake, VA 23321", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Norfolk", address: "5900 E Virginia Beach Blvd, Norfolk, VA 23502", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Portsmouth",
      address: "5401 E Portsmouth Blvd, Portsmouth, VA 23701",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Norfolk",
      address: "850 Widgeon Rd, Norfolk, VA 23513",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Chesapeake",
      address: "803 Corridor Ct, Chesapeake, VA 23320",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Chesapeake and western Portsmouth residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Suffolk",
      address: "1234 N Main St, Suffolk, VA 23434",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Suffolk and western Portsmouth. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Located in Norfolk, 10 miles from Portsmouth via Downtown Tunnel",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "The primary airport for Hampton Roads. Direct flights to major domestic destinations and international connections. Serves Portsmouth, Norfolk, and the entire Hampton Roads region.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: true,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "100 miles northwest of Portsmouth",
      address: "1 Richard E Byrd Terminal Dr, Richmond, VA 23250",
      note: "Alternative airport for domestic flights. Accessible via I-64.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "DCA",
      name: "Reagan National Airport",
      distance: "200 miles north of Portsmouth",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Major international hub for long-haul flights to Europe and Asia. Accessible via I-64 and I-95.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
  ],
};